import { IActionReducer } from "../../../redux/action.types"
import { planBTTypes } from "./planBT.types"

export interface IPlanBTState {
    isLoadingListPlanBT: boolean
    querySearch: string | null
}

const INITIAL_STATE: IPlanBTState = {
    isLoadingListPlanBT: false,
    querySearch: null
}

const planBTReducer = (state: IPlanBTState = INITIAL_STATE, action:  IActionReducer) => {
    switch (action.type) {
        case planBTTypes.IS_LOADING_LIST_PLANBT:
            return {
                ...state,
                isLoadingListPlanBT: action.payload
            }
        case planBTTypes.SET_QUERY_SEARCH:
            return {
                ...state,
                querySearch: action.payload
            }
        default:
            return state
    }
}

export default planBTReducer